<template>
  <div class="flexible-content">
    <!--Navbar-->
    <mdb-navbar class="flexible-navbar white" light position="top" scrolling>
      <mdb-navbar-brand href="https://sytsmafarms.com" target="_blank">
        Sytsma Farms
      </mdb-navbar-brand>
      <mdb-navbar-toggler class="navbar-toggle">
        <mdb-navbar-nav left>
          <router-link
            v-for="(link, index) in menuLinks"
            :key="index"
            :to="link.path"
            @click.native="activeItem = index"
          >
            <mdb-nav-item :class="activeItem === index && 'active'" waves-fixed>
              {{ link.displayName }}
            </mdb-nav-item>
          </router-link>
        </mdb-navbar-nav>
        <mdb-navbar-nav right>
          <mdb-nav-item v-if="user" waves-fixed>
            {{ user.email }}
          </mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
    <!--/.Navbar-->
    <main>
      <div class="mt-5 p-3 pt-5">
        <router-view />
      </div>
      <ftr class="text-center font-small darken-2">
        <hr class="my4" />
        <p class="footer-copyright mb-0 py-3 text-center">
          &copy; {{ new Date().getFullYear() }} Copyright:
          <a href="https://sytsmafarms.com">Sytsma Farms</a>
        </p>
      </ftr>
    </main>
  </div>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbFooter,
  waves
} from "mdbvue";
import { userService } from "./services/user.service";

export default {
  name: "AdminTemplate",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    ftr: mdbFooter
  },
  mixins: [waves],
  data() {
    return {
      user: {},
      activeItem: 0,
      menuLinks: [
        {
          path: "/farms",
          icon: "leaf",
          displayName: "Farms"
        },
        {
          path: "/services",
          icon: "clipboard-list",
          displayName: "Services"
        },
        {
          path: "/equipment",
          icon: "tractor",
          displayName: "Equipment"
        },
        {
          path: "/reports",
          icon: "file-download",
          displayName: "Reports"
        }
      ]
    };
  },
  beforeMount() {
    const page =
      this.$route.matched[0].props.default &&
      this.$route.matched[0].props.default.page;
    this.activeItem = page;
    this.user = userService.getLoggedInUser();
  }
};
</script>

<style scoped>
main {
  background-color: #f3f3f3;
}

.flexible-content {
  transition: padding-left 0.3s;
}

.flexible-navbar {
  transition: padding-left 0.5s;
}

.sidebar-fixed {
  left: 0;
  top: 0;
  height: 100vh;
  width: 270px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 1050;
  background-color: #fff;
  padding: 1.5rem;
  padding-top: 0;
}

.sidebar-fixed .logo-wrapper img {
  width: 100%;
  padding: 0.5rem;
}

.sidebar-fixed .list-group-item {
  display: block !important;
  transition: background-color 0.3s;
}

.sidebar-fixed .list-group .active {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
}

@media (max-width: 1199.98px) {
  .sidebar-fixed {
    display: none;
  }

  .flexible-content {
    padding-left: 0;
  }
  .flexible-navbar {
    padding-left: 10px;
  }
}
</style>
<style>
body,
td,
th,
.multiselect__tags,
.multiselect,
.multiselect__input,
.multiselect__single,
.form-control-lg {
  font-size: 1rem !important;
}

.multiselect__content-wrapper {
  border: 1px solid #000 !important;
}
.navbar-light .navbar-brand {
  margin-left: 15px;
  color: #085408 !important;
  font-weight: bolder;
}

.nav-item.active, .nav-item.active > .nav-link {
  color: #fff !important;
  background-color: #085408 !important;
}

.footer-copyright {
  color: #000 !important;
  background-color: unset !important;
}

.footer-copyright a {
  color: #085408 !important;
}

.list-group-item.active {
  background-color: #085408;
  border-color: #085408;
}

.btn-primary:active {
  background-color: #000 !important;
}

a:hover {
  text-decoration: underline !important;
}

.green,
.btn-primary {
  background-color: #085408 !important;
}

.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0px;
}

input[type="checkbox"] {
  width: 25px;
  height: 25px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
  margin-right: 1.3rem;
}
</style>
